import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class BrokerEntryRepository {
  constructor(private apiService: ApiService) {}

  public sentToCbp(entrySummaryId: number, isShowLoader: boolean = true): Observable<never> {
    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/entry-summaries/broker/sent-to-cbp`,
      null,
      {
        params: { id: entrySummaryId },
      },
      { isShowLoader },
    );
  }

  public sentToBroker(entrySummaryId: number, isShowLoader: boolean = true): Observable<never> {
    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/entry-summaries/broker/sent-to-broker`,
      null,
      {
        params: { id: entrySummaryId },
      },
      { isShowLoader },
    );
  }
}
